import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Loading from '@/components/business/Loading/Loading';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const AuthenticatedRoute = () => {
    const auth = useAuth();
    const [loading, setLoading] = useState(true);
    const browserLocation = useLocation();

    useEffect(() => {
        if (auth.state.email) {
            setLoading(false);
            return;
        }
        const timer = window.setTimeout(() => setLoading(false), 5000);
        return () => window.clearTimeout(timer);
    }, [auth.state.email]);

    if (!auth.state.email) {
        if (loading) {
            return <Loading loading timeoutMessage="Could not load route." />;
        }
        return <Navigate to={`/login?target=${browserLocation.pathname}`} />;
    }

    return <Outlet />;
};
